<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "formInput",
  
})
</script>
<template>
	<div class="formInput" :class="{currenFormBg:props?.round}">
		<w-form v-if="items" :layout="round > 1 ? 'vertical' : 'horizontal'" auto-label-width :disabled="!isLast">
			<template v-for="item in items">
				<template v-if="item.attributes['data-type'] === 'radio'">
					<w-form-item field="name" :label="item.attributes['data-name']">
						<w-radio-group v-model="modelValue[item.attributes['data-key']]" @change="handleChange(item)">
							<w-space wrap>							
								<w-radio class="message-form-input-radio" :class="{ disableeRadio:disbaledstatus&&item.attributes['data-key']=='sex',RadioDisSelect:disabledRadio&&item.attributes['data-key']!='sex',currentSelectRadio:item.attributes['data-key']!='sex' }" :value="i.key" :disabled="from=='share'||chatStore.getListHistory" v-for="(i, key) in item.attributes['data-vals']" :key="key">
									<template #radio="{ checked }">
										<w-tag class="message-form-input-tag"  :class="[checked ? 'checked' : '',disbaledstatus||disabledRadio?'disAbleHover':'',chatStore.getListHistory?'disabledBtn':'']" :checked="checked" color="winboxblue" checkable>{{
											i.name
										}}</w-tag>
									</template>
								</w-radio>
							</w-space>
						</w-radio-group>
					</w-form-item>
				</template>
				<template v-else-if="item.attributes['data-type'] === 'input'">
					<w-form-item field="name" :label="item.attributes['data-name']">
						<w-input-number
							@input="handleChange"
							hide-button
							class="message-form-input-input"
							style="width: 150px"
							:class="{ disableeInput: disbaledstatus }"
							v-model="modelValue[item.attributes['data-key']]"
							:placeholder="item.attributes['data-placeholder']"
							:precision="0"
							:min="1"
							:max="200"
							:disabled="chatStore.getListHistory"
    						modelEvent="input"
							><template #append> 岁 </template>
						</w-input-number>
					</w-form-item>
				</template>
				<template v-else-if="item.attributes['data-type'] === 'submit'">
					<w-form-item hide-label>
					<w-button
					block
						:key="item.attributes['data-key']"
						:class="{ disableeBtn: disbaledstatus||disabledRadio}"
						:disabled="!hasValidModelValue||from=='share'||chatStore.getListHistory"
						type="primary"
						@click="handleSubmit(item.attributes['data-name'])"
						>{{ item.attributes['data-name'] }}</w-button
					>
				</w-form-item>			
				</template>
			</template>
		</w-form>
	</div>
</template>

<script setup lang="ts" name="formInput">
import { useChatStore } from '/@/stores/chat';
import { ref, onMounted, reactive, computed, nextTick, watch, defineAsyncComponent, onBeforeUnmount, onUnmounted ,toRefs} from 'vue';
import { Message } from 'winbox-ui-next';

import { useRoute } from 'vue-router';
import { getTicketId } from '/@common/utils/utils';
const route = useRoute();
const chatStore = useChatStore();
const hasValidModelValue = ref(false);
const modelValue = ref({});

const formData = reactive({});


// 定义 Item 接口
interface Item {
    attributes: {
        [key: string]: any; // 你可以根据实际情况细化这个类型
    };
}
const props = defineProps<{
	items: Item[]; // 子组件接收
	from?: string;
	round: number;
	chatType: number;
	uuid?: string;
	isLast?: boolean;
	gender?: string;
	dialogueId?: string;
	age?: number;
	index?:number
}>();
const { items } = toRefs(props);

const disabledRadio=computed(() => {
	return props?.round>=0&&props?.index &&props?.index<chatStore.chatList.length-1||chatStore.getListHistory||props?.from == 'share'
})
// const itemsData = computed(() => {
// 	return items.value;
// });

// items.value.forEach((item) => {
// 	item.attributes['val'] = item.attributes['model-value'];
// });

const handleKeydown = (event,item) => {
	console.log(event,item)
	// handleChange(item);
	// const currentValue = modelValue.value[item.attributes['data-key']] + '';
	// modelValue.value[item.attributes['data-key']] = currentValue + event.target.value
	// const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
    //     if (!allowedKeys.includes(event.key)) {
    //         event.preventDefault();
    //         return;
    //     }

    //     const currentValue = modelValue.value[item.attributes['data-key']] + '';
    //     const newValue = currentValue.slice(0, event.target.selectionStart) + event.key + currentValue.slice(event.target.selectionEnd);

    //     if (newValue.startsWith('0') && newValue.length > 1) {
    //         event.preventDefault();
    //         return;
    //     }

    //     if (newValue && (parseInt(newValue) < 1 || parseInt(newValue) > 200)) {
    //         event.preventDefault();
    //     }
    }


const getDefaultValue = (value: any): number | string => {
  if (value !== undefined && value !== null && value !== '') {
    return +value;
  }
  return '';
};





// const getFormData = () => {
//   for (const item of items.value) {
//     if (item.attributes['data-type'] !== 'submit') {
//       if (!item.attributes.hasOwnProperty('val') || item.attributes['val'] === null || item.attributes['val'] === undefined || item.attributes['val'] === '') {
//         return null;
//       }
//     }
//   }

//   return items.value.reduce((acc, item) => {
//     if (item.attributes['data-type'] !== 'submit') {
//       acc[item.attributes['data-key']] = item.attributes['val'];
//     }
//     return acc;
//   }, {});
// };

const getFormData = () => {
  const formData = modelValue.value;
  // 检查对象是否有空值
  const hasEmptyValues = Object.values(formData).some(value => value === null || value === undefined || value === '');

  if (hasEmptyValues) {
    return null;
  } else {
    return formData;
  }
}


const handleChange = async (item) => {
	await nextTick();
	const mark = getFormData();
	if (mark) {
		hasValidModelValue.value = true;
	}else {
		hasValidModelValue.value = false;
	}
	try {
		const {attributes} = item
	if (attributes['data-type'] == "radio") {
		const vals = attributes['data-vals']
		const foundItem = vals.find(it => it.key === modelValue.value[item.attributes['data-key']]);
		if (props.round > 1) {
		const data = {
			'optionQuestion': attributes['data-name'],
			'score': foundItem.score,
		}
			// console.log(foundItem.name,data);
			handleSubmit(foundItem.name,data)
		}
	}
	} catch (error) {

	}
	}


const handleSubmit = (name='',item?:any) => {
	const formData = getFormData();
	if (formData === null) {
		return
	}
	let text = '';
	let other‌Data = {};
	if (props.round == 0) {
		text = `${formData?.sex} ${formData?.age}岁`;
		other‌Data = {gender: formData?.sex, age: formData?.age}
	}else if (props.round == 1) {
		text = name;
	} else if (props.round > 1) {
		other‌Data = item
		text = name;
	}
	const data = {
		appId: chatStore.bgRoleId || '21',
		// content:props.formData?.isParseUrl?textTransform(text):text,
		content: text,
		conversationId: props.from == 'debug' ? chatStore.debugConversationId : route.params.conversationId,
		param: '',
		isDebug: props.from == 'debug' ? true : false,
		round: props.round + 1,
		chatType: props.chatType,
		uuid: props.uuid,
		gender: props.gender||modelValue.value?.sex,
		age: props.age||modelValue.value?.age,
		privateDialogueId:props.dialogueId,
		...other‌Data,
	};
	if (chatStore.categoryId != '-1') {
		data['categoryId'] = chatStore.categoryId;
	}
	chatStore.setChatList(data);
};
onMounted(() => {
	items.value.forEach((item) => {
		if (item.attributes['data-key']) {
			modelValue.value[item.attributes['data-key']] = item.attributes['model-value'];
		}
	})
	getInfo()
	handleChange();
});
const disbaledstatus=computed(()=>{
	return ((props?.gender||modelValue.value?.sex)&&(props?.age||modelValue.value?.age)&&props?.index<chatStore.chatList.length-1)||chatStore.getListHistory||props?.from == 'share'
})
const getInfo=()=>{
	let data=chatStore.lastItem
	modelValue.value['sex']=props?.gender||data?.gender
	modelValue.value['age']=props?.age||data?.age
}

// 在组件卸载前清除定时器
onUnmounted(() => {});
</script>

<style scoped lang="scss">
.formInput {
	background: #f4f6f9;
	border-radius: 8px;
	padding: 12px;
	padding-bottom: 0px;
	:deep(.w-form-item) {
		margin-bottom: 12px;
		&:last-child {
			margin-bottom: 0;
		}
	}
	:deep(.w-btn){
		border-radius: 8px;
	}
	.disableeBtn{
		background-color:  #BBC1C8 !important;
	}
	.message-form-input-radio {
		padding: 0;
		margin-right: 0px;
		&.w-radio-disabled {
			.w-tag {
				cursor: not-allowed !important;
			}
		}
		// margin-bottom: 10px;
	}
	.message-form-input-tag {
		background-color: #fff;
		border-color: #fff;
		padding: 0 16px;
		border-radius: 8px;
		&.checked,
		&.checked:hover {
			border-color: rgb(var(--winboxblue-6)) !important;
		}
		&:hover{
			background-color: rgba(255,255,255,0.06) !important;
		}
	}
	.disableeRadio{

		.message-form-input-tag {
			color: #646479 !important;
			border-color: #fff;
			&.checked{
				border-color: #9A99AA !important;
				background: rgba(209,208,220,0.3);
				font-family:  MiSansMedium;
				font-weight: 500;
				color: #181B49 !important;
			}
		}
		.disAbleHover{
			&.checked:hover{
				background: rgba(209,208,220,0.3) !important;
				
			}
			&:hover{
			background-color: #fff !important;
		   }
		}
		.disabledBtn{
			&:hover{
			background-color: #f4f6f9 !important;
		   }
		}

}
.currentSelectRadio{
	.message-form-input-tag {
		    color: #181B49 !important;
			background: rgba(53,94,255,0.1) !important;
			border-color: transparent;
			&.checked{
				border-color:#355EFF !important;
				color: #145AFE !important;
				font-family:  MiSansMedium;
				font-weight: 500;
			}
			&:hover{
				color:  #145AFE !important;
			}
		}
}
.RadioDisSelect{
	.message-form-input-tag {
		    color: #646479 !important;
			background: #F4F6F9 !important;
			border-color: transparent;
			&.checked{
				border-color:#9A99AA !important;
				color: #181B49 !important; 
				background: #F4F6F9 !important;
				font-family:  MiSansMedium !important;
				font-weight: 500 !important;
			}
			&:hover{
				color: #646479 !important;
			}
			
		}
		.disAbleHover{
			&.checked:hover{
				color: #181B49 !important; 
				
			}
			&:hover{
				color: #646479 !important;
		   }
		}
}
	.message-form-input-input {
		border-radius: 8px;
		overflow: hidden;
		:deep(.w-input-wrapper) {
			border: none;
		}
		:deep(.w-input-append) {
			border: none;
		}
	}
	.disableeInput{
		// background-color: #fff !important;
		:deep(.w-input-wrapper.w-input-disabled){
			background-color: #fff !important;
		}
	}
}
.currenFormBg{
	background-color: #fff;
}
</style>
<style lang="scss">
.formInput{
	.w-form-auto-label-width .w-form-item-label-col > .w-form-item-label{
		white-space: normal;
	}
}
</style>